<template>
    <a v-if="!is_group" href="#" class="list-group-item pl-5" @click="switchAccount">
        <i class="far fa-money-bill-alt fa-fw bills"></i>{{ name }}
        <span class="badge badge-secondary float-right">
      {{ $filters.formatBalance(balance) }} €
    </span>
    </a>

    <div v-else>
        <a class="list-group-item" href="#" @click="toggleList">
            <i
                class="fas fa-fw bills"
                v-bind:class="{'fa-angle-right': !show_list, 'fa-angle-down': show_list,}"
            ></i>{{ name }}
        </a>
        <div v-if="show_list" class="list-group">

            <li
                is="AccountButton"
                v-for="(acc, index) in filteredAccounts"
                v-bind:key="acc.id"
                v-bind:acc_obj=acc
                :index="index"
                :name="acc.name"
                v-bind:is_group=acc.is_group
                v-bind:accounts=acc.accounts
            ></li>

        </div>
    </div>

</template>
<script>
import axios from "axios";
//let $ = JQuery
export default {
    name: 'AccountButton',
    props: {
        name: String,
        is_group: true,
        accounts: {
            type: Array,
            default: () => []
        },
        acc_obj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            show_list: true,
        }
    },
    methods: {
        toggleList(event) {
            event.preventDefault();
            event.stopPropagation();
            this.show_list = !this.show_list
        },
        switchAccount(event) {
            event.preventDefault();
            event.stopPropagation();
            console.log('switchAccount called');
            if (this.is_group) {
                console.log('Don\'t switch group');
                return;
            }
            console.log('this.name:', this.name);
            console.log('this.acc_obj:', this.acc_obj);

            this.loadBalance()
            this.$store.dispatch('switchAccount', this.name).then(() => {
                this.$store.dispatch('loadData');
            });
        },
        loadBalance() {
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: process.env.VUE_APP_ROOT_API + "/account/" + this.name + "/balance",
                method: "get",
                auth: credentials
            })
                .then(response => {
                    this.balance = response.data.balance;
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                });
        }
    },
    computed: {
        filteredAccounts() {
            return this.accounts.filter(function (acc) {
                return !(acc.name.endsWith("_INCOME") || acc.name.endsWith("_EXPENSE"));
            })
        },
        balance() {
            if (!(this.is_group) && this.acc_obj) {
                return this.acc_obj.balance
            } else {
                return 0;
            }
        }
    },
    mounted() {
        //if (true) {
        if (!(this.is_group)) {
            this.balance = this.acc_obj.balance
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-group-item {
    padding: 6px 10px
}

.pl-5 {
    padding-left: 2.2rem !important;
}
</style>
